(function () {
  var STORAGE_KEY = 'ok_preloader_shown';
  var MIN_VISIBLE_MS = 900;
  var alreadyShown = false;
  try {
    alreadyShown = sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    alreadyShown = false;
  }

  var preloader = document.getElementById('site-preloader');
  if (!preloader) return;

  if (alreadyShown) {
    preloader.setAttribute('hidden', 'hidden');
    document.body.classList.remove('site-preloader-active');
    return;
  }

  document.body.classList.add('site-preloader-active');
  var startTime = Date.now();

  function hidePreloader() {
    var elapsed = Date.now() - startTime;
    var wait = Math.max(MIN_VISIBLE_MS - elapsed, 0);
    setTimeout(function () {
      preloader.setAttribute('hidden', 'hidden');
      document.body.classList.remove('site-preloader-active');
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    }, wait);
  }

  if (document.readyState === 'complete') {
    hidePreloader();
  } else {
    window.addEventListener('load', hidePreloader);
    setTimeout(hidePreloader, 5000);
  }
})();
